const { createContext, useState, useContext } = require('react')

const SearchTableContext = createContext()

export const SearchTableProvider = ({ children }) => {
  const [inputValue, setInputValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')

  const handleOnChange = e => {
    setInputValue(e.target.value)
  }

  const handleOnSubmit = e => {
    e.preventDefault()
    setSearchedValue(inputValue)
  }

  const resetInfo = () => {
    setInputValue('')
    setSearchedValue('')
  }

  const value = {
    inputValue,
    searchedValue,
    handleOnChange,
    handleOnSubmit,
    resetInfo,
  }

  return (
    <SearchTableContext.Provider value={value}>
      {children}
    </SearchTableContext.Provider>
  )
}

export const useSearchTable = () => {
  const context = useContext(SearchTableContext)
  if (!context) {
    throw new Error('useSearchTable must be used within a SearchTableProvider')
  }
  return context
}
